module.exports = __webpack_public_path__ + "static/media/afori_logo_neg.82ee9696.svg";